module.exports = __webpack_public_path__ + "img/62-2.5627a05a.png";